import React, { useState } from 'react';
import { Copy } from 'sushiweb/Icons';
import { green } from 'sushiweb/tokens/color';
import { copyToClipboard } from '../../components/commons/CommonMethods';
import './copyTextIcon.scss';

const CopyTextIcon = ({ textToCopy }) => {
  const [isCopied, setIsCopied] = useState(false);

  // Function to copy the text and show the "copied" message
  const handleCopy = (text) => {
    copyToClipboard(text);
    setIsCopied(true);
  };

  if (!textToCopy) return null;

  return (
    <div className="copyWrapper">
      {isCopied ? (
        <p className="tw-text-green-700 tw-font-medium tw-text-200">Copied</p>
      ) : (
        <span className="copyIcon" onClick={() => handleCopy(textToCopy)}>
          <Copy size={15} color={green.z700} style={{ cursor: 'pointer' }} aria-label="Copy text" />
        </span>
      )}
    </div>
  );
};

export default CopyTextIcon;
